import React from 'react';
import PropTypes from 'prop-types';

import { formatCourseLevel } from '../../utils/courseLevel';
import usePreviewFeature from '../../hooks/usePreviewFeature';

const formatLabel = (type) => {
  const value = String(type || '').trim();
  if (!value) {
    return '';
  }

  return /формат/i.test(value) ? value : `${value} формат`;
};

const CourseHead = ({ image, title, programName, type, onClick, actionLabel, children }) => {
  const isLeadTitle = usePreviewFeature('finance-course-heading');
  const level = programName ? formatCourseLevel(programName) : '';
  const format = formatLabel(type);
  const hasChips = Boolean(level || format);
  const className = [
    'fv2-head',
    isLeadTitle && 'fv2-head--lead',
    isLeadTitle && !image && 'fv2-head--no-flag',
    isLeadTitle && image && !hasChips && 'fv2-head--no-chips',
  ].filter(Boolean).join(' ');

  const content = (
    <>
      {image && <img className="fv2-head__flag" src={image} alt="" width="48" height="32" decoding="async" />}
      <div className="fv2-head__main">
        <h3 className="fv2-head__title">{title}</h3>
        {hasChips && (
          <div className="fv2-head__chips">
            {level && <span className="v2-chip">{level}</span>}
            {format && <span className="v2-chip">{format}</span>}
          </div>
        )}
      </div>
      {children && <span className="fv2-head__side">{children}</span>}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={`${className} fv2-head--link`} aria-label={actionLabel || title} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className={className}>{content}</div>;
};

CourseHead.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  programName: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  actionLabel: PropTypes.string,
  children: PropTypes.node,
};

CourseHead.defaultProps = {
  image: '',
  title: '',
  programName: '',
  type: '',
  onClick: null,
  actionLabel: '',
  children: null,
};

export default CourseHead;
